module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_14.69d00cb0.png";